import logoMark from "@/assets/logo-mark.png";

export function Logo({ size = 26, className = "" }) {
  return (
    <img
      src={logoMark}
      alt="ModernTect"
      width={size}
      height={size}
      className={className}
      data-testid="app-logo-mark"
    />
  );
}
